export default __webpack_public_path__ + "static/media/cs_icon_09_on.36518300.png";